import { render } from "./QuizIcon.vue?vue&type=template&id=d2649d9c&scoped=true"
import script from "./QuizIcon.vue?vue&type=script&lang=js"
export * from "./QuizIcon.vue?vue&type=script&lang=js"

import "./QuizIcon.vue?vue&type=style&index=0&id=d2649d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2649d9c"]])

export default __exports__